import type { CharterFeederPricesBulkPayload, CharterFeederPricesRow } from '~/services/FlightsService';

export const CHARTER_FEEDER_DATE_FIELD = 'date';
export const CHARTER_FEEDER_DIRECTION_FIELD = 'direction';
export const CHARTER_FEEDER_ORIGIN_FIELD = 'originAirportCode';
export const CHARTER_FEEDER_DESTINATION_FIELD = 'destinationAirportCode';
export const CHARTER_FEEDER_BASE_SUFFIX = '__basePrice';
export const CHARTER_FEEDER_BUFFER_SUFFIX = '__bufferPrice';

export type CharterFeederSheetCellValue = string | number | null;

export type CharterFeederSheetRow = {
  id: string;
  [CHARTER_FEEDER_DATE_FIELD]: string;
  [CHARTER_FEEDER_ORIGIN_FIELD]: string;
  [CHARTER_FEEDER_DESTINATION_FIELD]: string;
} & Record<string, CharterFeederSheetCellValue>;

export interface CharterFeederColumn {
  code: string;
  isNew: boolean;
}

export interface NormalizedCharterFeederSheet {
  rows: Array<CharterFeederSheetRow>;
  columns: Array<CharterFeederColumn>;
}

export interface BuildCharterFeederBulkPayloadResult {
  payload: CharterFeederPricesBulkPayload;
  hasChanges: boolean;
  validationErrors: Array<string>;
}

export type CharterFeederPersistedRow = CharterFeederPricesRow;
